import React from "react";
import YearlySalesChart from "../../components/Report/YearlySalesChart";

const ReportYearlySalesChartPage: React.FC = () => <YearlySalesChart />;
export default ReportYearlySalesChartPage;
